import { create } from 'zustand';
import type { FeedsConfigSetting, FeedsStatusDto } from '@ecom/contracts';
import { adminApi, errorMessage, withSession } from '@/lib/api-client';

/** The setting the feeds read (ADR-096); written through the settings API like every section. */
export const FEEDS_KEY = 'marketing.feeds';

/** Product feeds (ADR-096): the check the API runs, and the store's choices. */
interface FeedsState {
  status: FeedsStatusDto | null;
  loading: boolean;
  saving: boolean;
  error: string | null;

  load: () => Promise<void>;
  save: (config: FeedsConfigSetting) => Promise<boolean>;
}

export const useFeedsStore = create<FeedsState>((set, get) => ({
  status: null,
  loading: false,
  saving: false,
  error: null,

  async load() {
    set({ loading: true, error: null });
    try {
      const status = await withSession(() => adminApi.feeds.status());
      set({ status, loading: false });
    } catch (error) {
      set({ loading: false, error: errorMessage(error, 'Could not check the product feeds.') });
    }
  },

  async save(config) {
    set({ saving: true, error: null });
    try {
      await withSession(() => adminApi.settings.update(FEEDS_KEY, config));
      set({ saving: false });
      // The check reads the new choices: out-of-stock rows in or out change the count.
      await get().load();
      return true;
    } catch (error) {
      set({ saving: false, error: errorMessage(error, 'Could not save the feeds.') });
      return false;
    }
  },
}));
